<template>
  <div class="tab-pane fade in active" id="mydrive">
    <div class="mychilidTab-box clearfix">
      <ul class="nav nav-tabs child-tabs" id="mychlidTab">
        <li
          v-for="list in tabs"
          :key="list.id"
          :class="{ active: list.href === tab }"
          @click="switchTabByClick(list)"
          v-show="list.display"
        >
          <a :href="'#' + list.href" data-toggle="tab">{{ list.name }}</a>
        </li>
      </ul>
      <div class="button-container" style="display: block">
        <NewFolder
          v-if="false"
          :isShowNewFolder="isShowUpload"
          @createNewFolder="createNewFolder"
        ></NewFolder>
        <Upload v-if="false" :isShowUpload="isShowUpload"></Upload>
        <Tag :isShowTag="isShowTag" @filterByTag="filterByTag"></Tag>
        <List
          :isShowList="isShowList"
          :isList="isList"
          @showList="showList"
        ></List>
      </div>
    </div>
    <div class="filepath">
      <a
        @click="getInfoByFatherId('up')"
        :class="{ 'no-click': noClick }"
        v-if="['file', 'star', 'trash'].indexOf(tab) > -1"
        >返回上一级</a
      >
      <a
        @click="getShareResourceList('up')"
        :class="{ 'no-click': noClick }"
        v-if="['sharefile', 'shareme'].indexOf(tab) > -1"
        >返回上一级</a
      >
      <span class="line">|</span>
      <a @click="getAllInfo">{{ bread }}</a>
      <span
        v-for="lel in level"
        :key="lel.number"
        v-show="['file', 'star'].indexOf(tab) > -1"
      >
        <i class="ti-angle-right"></i>
        <a @click="getInfoByFatherId(lel)">{{ lel.name }}</a>
      </span>
      <span
        v-for="(lel, index) in level"
        :key="lel.index"
        v-show="['sharefile', 'shareme'].indexOf(tab) > -1"
      >
        <span class="line">></span>
        <a @click="getShareResourceList(lel)">{{
          index === 0 ? lel.share_title : lel.name
        }}</a>
      </span>
    </div>
    <keep-alive>
      <component
        :is="table"
        :isList="isList"
        :isCreateProcessing="isCreateProcessing"
        @getInfoByFatherId="getInfoByFatherId"
        @getShareResourceList="getShareResourceList"
        @saveNewFolder="saveNewFolder"
        @createNewFolder="createNewFolder"
        @updateCreateProcessing="updateCreateProcessing"
      ></component>
    </keep-alive>
  </div>
</template>

<script>
import { shareInfo, shareTargetInfo } from "@/api/share/share";
import { fileOrFolderInfo } from "@/api/drive/drive";
export default {
  name: "CloudDisk",
  components: {
    NewFolder: () => import("@/views/Common/NewFolder"),
    Upload: () => import("@/views/Common/Upload"),
    List: () => import("@/views/Common/List"),
    Tag: () => import("@/views/Common/Tag"),
    Table: () => import("@/components/Table/Table"),
    TableShareResource: () => import("@/components/Table/TableShareResource"),
  },
  data() {
    return {
      isCreateProcessing: false, // 是否正在请求创建文件夹
      file: {},
      tagListQuery: {
        userId: null,
      },
      bread: "全部",
      level: [],
      isShowUpload: false,
      isShowList: false,
      isShowTag: false,
      searchTab: {
        file: 0,
        star: 1,
        trash: 2,
        sharefile: 3,
        shareme: 4,
      },
      tabs: [
        {
          id: 1,
          table: "Table",
          name: "文件",
          bread: "全部",
          href: "file",
          isShowUpload: true,
          isShowList: true,
          isShowTag: true,
          drive: "my",
          query: {
            disk_type: "cloud",
            category: "all",
            is_star: false,
            is_rec: false,
            number: 0,
          },
          display: true,
        },
        {
          id: 2,
          table: "Table",
          name: "已标星",
          bread: "全部",
          href: "star",
          isShowUpload: false,
          isShowList: true,
          isShowTag: false,
          drive: "my",
          query: {
            disk_type: "cloud",
            category: "all",
            is_star: true,
            is_rec: true,
          },
          display: true,
        },
        {
          id: 4,
          table: "Table",
          name: "已分享",
          bread: "全部",
          href: "sharefile",
          isShowUpload: false,
          isShowList: true,
          isShowTag: false,
          drive: "my",
          query: {
            share_type: "user|group|link",
          },
          display: false,
        },
        {
          id: 5,
          table: "Table",
          name: "分享@我",
          bread: "全部",
          href: "shareme",
          isShowUpload: false,
          isShowList: true,
          isShowTag: false,
          drive: "my",
          query: {
            disk_type: "cloud",
            category: "all",
          },
          display: false,
        },
        {
          id: 3,
          table: "Table",
          name: "回收站",
          bread: "全部",
          href: "trash",
          isShowUpload: false,
          isShowList: false,
          isShowTag: false,
          drive: "my",
          query: {
            disk_type: "recycle",
            category: "all",
          },
          display: true,
        },
      ],
      temp: {
        number: null,
        group_number: null,
        name: "新建文件夹",
        type: "folder",
        bytes: "",
        last_update_date: "--",
        creater_user_real_name: "--",
        isStar: false,
        disk_type: "cloud",
        isEdit: true,
        isCreate: true,
        isSelected: false,
      },
    };
  },
  created() {
    let tab = this.$route.query.tab;
    if (tab) {
      switch (tab) {
        case "file":
          this.jumpToMyDrive("file");
          if (this.$route.query.number) {
            this.file = {
              disk_type: this.$route.query.disk_type,
              number: this.$route.query.number,
            };
            this.getFileInfoForSearch();
          } else {
            this.getInfo();
          }
          break;
        case "shareme":
          this.jumpToMyDrive("shareme");
          if (this.$route.query.share_number) {
            this.file = {
              share_number: this.$route.query.share_number,
            };
            this.getShareMeInfoForSearch();
          } else {
            this.getInfo();
          }
          break;
        case "myshare":
          this.jumpToMyDrive("sharefile");
          if (this.$route.query.share_number) {
            this.file = {
              share_number: this.$route.query.share_number,
            };
            this.getMyShareInfoForSearch();
          } else {
            this.getInfo();
          }
          break;

        default:
          break;
      }
    } else {
      // 使用之前选择的drive和tab状态
      this.jumpToMyDrive("file");
      this.switchTab(this.tabs[this.searchTab[this.tab]]);
    }
  },
  computed: {
    isList() {
      return this.$store.state.drive.isList;
    },
    noClick() {
      return this.level.length ? false : true;
    },
    table() {
      let tab = this.tabs.find((tab) => tab.href === this.tab);
      return tab.table;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    datas() {
      return this.$store.state.drive.datas;
    },
    listQuery() {
      return this.$store.state.drive.listQuery;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
  },
  watch: {
    tab() {
      this.level = [];
    },
    $route(to) {
      let tab = to.query.tab;
      if (tab) {
        switch (tab) {
          case "file":
            this.jumpToMyDrive("file");
            if (to.query.number) {
              this.file = {
                disk_type: to.query.disk_type,
                number: to.query.number,
              };
              this.getFileInfoForSearch();
            } else {
              this.getInfo();
            }
            break;
          case "shareme":
            this.jumpToMyDrive("shareme");
            if (to.query.share_number) {
              this.file = {
                share_number: to.query.share_number,
              };
              this.getShareMeInfoForSearch();
            } else {
              this.getInfo();
            }
            break;
          case "myshare":
            this.jumpToMyDrive("sharefile");
            if (to.query.share_number) {
              this.file = {
                share_number: to.query.share_number,
              };
              this.getMyShareInfoForSearch();
            } else {
              this.getInfo();
            }
            break;

          default:
            break;
        }
      } else if (to.name === "recdrive") {
        switch (this.tab) {
          case "file":
            this.file = {
              disk_type: to.query.disk_type ? to.query.disk_type : "cloud",
              number: to.query.number ? to.query.number : 0,
            };
            this.getFileInfoForSearch();
            break;
          default:
            this.getAllInfo();
            break;
        }
      }
    },
  },
  methods: {
    jumpToMyDrive(tab) {
      this.$store.commit("SWITCH_DRIVE", {
        drive: "my",
        group: null,
        tab: tab,
      });
      this.$store.commit("sortById", 3);
    },
    /**
     * 跳转到我的分享的固定子分享
     */
    getMyShareInfoForSearch() {
      this.level = [];
      this.isShowUpload = false;
      this.isShowList = true;
      this.isShowTag = false;
      shareInfo({
        share_number: this.file.share_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.getShareResourceList(res.entity);
          } else {
            this.$message({
              type: "warning",
              message: `${res.message} 正在跳转到我的分享列表...`,
            });
            setTimeout(() => {
              this.switchTab(this.tabs[2]);
            }, 1000);
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    /**
     * 跳转到分享@我的固定子分享
     */
    getShareMeInfoForSearch() {
      this.level = [];
      this.isShowUpload = false;
      this.isShowList = true;
      this.isShowTag = false;
      shareTargetInfo({
        share_number: this.file.share_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.getShareResourceList(res.entity);
          } else {
            this.$message({
              type: "warning",
              message: `${res.message} 正在跳转到分享@我列表...`,
            });
            setTimeout(() => {
              this.switchTab(this.tabs[3]);
            }, 1000);
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    /**
     * 跳转到文件的固定子目录
     */
    getFileInfoForSearch() {
      this.level = [];
      this.isShowUpload = this.file.disk_type === "cloud" ? true : false;
      this.isShowList = true;
      this.isShowTag = this.file.disk_type === "cloud" ? true : false;
      this.$store.commit("MODIFY_LIST_QUERY", {
        number: this.file.number,
        disk_type: this.file.disk_type,
        is_rec: false,
        offset: null,
        limit: null,
      });
      this.getBread(this.file.number);
      this.getInfo();
    },
    getBread(number) {
      if (number == "0") {
        return false;
      }
      fileOrFolderInfo({
        type: "folder",
        number: number,
        is_path: true,
        group_number: this.groupNumber,
      })
        .then((res) => {
          if (res.status_code === 200) {
            if (res.entity.parent_path_number.length > 1) {
              let parent_path_number = res.entity.parent_path_number
                .slice(1)
                .split("/");
              let parent_path_name = res.entity.parent_path_name
                .slice(1)
                .split("/");
              this.level = parent_path_number.map((item, index) => {
                return {
                  number: item,
                  name: parent_path_name[index],
                };
              });
            }
            this.level.push({
              number: res.entity.number,
              name: res.entity.name,
            });
          }
        })
        .catch();
    },

    /**
     * 点击跳转tab
     * 规则：点击当前所在的tab不用
     **/
    switchTabByClick(tab) {
      if (tab.href != this.tab) {
        this.switchTab(tab);
      }
    },
    switchTab(tab) {
      this.bread = tab.bread;
      this.level = [];
      tab.table = "Table";
      this.$store.commit("SWITCH_TAB", tab.href);
      this.isShowUpload = tab.isShowUpload;
      this.isShowList = tab.isShowList;
      this.isShowTag = tab.isShowTag;
      this.getInfo();
    },
    getInfo() {
      this.$store.dispatch("getInfo").then((res) => {
        if (res.status_code === 410) {
          this.$router.push({
            name: "recdrive",
            query: {
              s: new Date().getTime(),
            },
          });
        } else {
          if (!this.isList) {
            if (this.tab === "shareme") {
              this.$store.dispatch("getShareImgPath");
            } else {
              this.$store.dispatch("getImgPath");
            }
          }
        }
      });
    },
    getInfoByFatherId(data) {
      let res = this.level.find((item) => item.number === data.number);
      let index = this.level.indexOf(res);
      if (index > -1) {
        this.level.splice(index + 1, this.level.length - index - 1);
      } else if (data === "up") {
        if (this.noClick) {
          return false;
        } else {
          this.level.pop();
        }
      } else {
        this.level.push(data);
      }
      this.$store.commit("MODIFY_LIST_QUERY", {
        number:
          this.level.length === 0
            ? 0
            : this.level[this.level.length - 1].number,
        disk_type:
          this.level.length === 0
            ? "cloud"
            : this.level[this.level.length - 1].disk_type,
        // offset: 0,
        // limit: 5
      });
      this.getInfo();
    },
    getShareResourceList(data) {
      let index;
      if (this.level.length > 0) {
        index = this.level.indexOf(data);
      } else {
        let res = this.level.find((item) => {
          return (
            item.share_number === data.share_number ||
            item.number === data.number
          );
        });
        index = this.level.indexOf(res);
      }
      if (index > -1) {
        this.level.splice(index + 1, this.level.length - index - 1);
      } else if (data === "up") {
        if (this.noClick) {
          return false;
        } else {
          this.level.pop();
        }
      } else {
        this.level.push(data);
      }
      let tab = this.tabs.find((item) => item.href === this.tab);
      if (this.level.length === 0) {
        this.$store.commit("setDatas", []);
        tab.table = "Table";
        this.getInfo();
        return false;
      } else {
        this.$store.commit("setDatas", []);
        tab.table = "TableShareResource";
      }
      this.$store
        .dispatch("getShareResourceList", {
          share_creater_name: data.share_creater_name,
          share_number:
            this.level.length === 0
              ? data.share_number
              : this.level[0].share_number,
          share_resource_number:
            this.level.length < 2
              ? null
              : this.level[this.level.length - 1].number,
          is_rec: "false",
        })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setLoading", false);
            this.$store.commit("GET_RESOURCE_INFO", res.entity);
            if (!res.entity.length) {
              this.$store.commit("setNothing", true);
            } else {
              this.$store.commit("sortByDefault", 3);
              this.$store.commit("sortByHeader");
              if (!this.isList) {
                this.$store.dispatch("getShareImgPath");
              }
            }
          } else if (res.status_code === 439) {
            this.$store.commit("setLoading", false);
            this.$store.commit("setShareExpired", true);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    filterByTag(tagName) {
      this.listQuery.tag = tagName;
      this.$store.commit();
      this.getInfo();
    },
    getAllInfo() {
      if (
        ["star", "sharefile", "persona-sharefile", "shareme"].indexOf(
          this.$store.state.drive.tab
        ) > -1
      ) {
        this.$store.commit("setDatas", []);
      }
      let tab = this.tabs.find((item) => item.href === this.tab);
      tab.table = "Table";
      this.level = [];
      this.$store.commit("MODIFY_LIST_QUERY", {
        number: 0,
        disk_type: this.tab === "file" ? "cloud" : this.listQuery.disk_type,
        offset: 0,
        // limit: 5
      });
      this.getInfo();
    },
    showList(isList) {
      this.$store.commit("setIsList", isList);
      if (!isList) {
        if (this.tab === "shareme") {
          this.$store.dispatch("getShareImgPath");
        } else {
          this.$store.dispatch("getImgPath");
        }
      }
    },
    createNewFolder() {
      this.temp.disk_type = this.level.length
        ? this.level[this.level.length - 1].disk_type
        : "cloud";
      this.$store.commit("createNewFolder", Object.assign({}, this.temp));
      this.$nextTick(function () {
        this.$store.commit("setFocusState", true);
      });
    },
    updateCreateProcessing(status) {
      this.isCreateProcessing = status;
    },
    saveNewFolder(folderName) {
      this.isCreateProcessing = true;
      this.$store
        .dispatch("newFolders", {
          group_number: "",
          number:
            this.level.length === 0
              ? "0"
              : this.level[this.level.length - 1].number,
          paramslist: [folderName],
          disk_type: this.level.length
            ? this.level[this.level.length - 1].disk_type
            : "cloud",
        })
        .then((res) => {
          if (res.status_code === 200) {
            this.isCreateProcessing = false;
            this.$nextTick(function () {
              this.$store.commit("setFocusState", false);
            });
            this.$message({
              type: "success",
              message: res.message,
            });
            this.$store.commit("changeDataOfDatas", {
              number: res.entity[0].number,
              name: res.entity[0].new_name,
              creater_user_real_name: this.$store.state.user.userInfo.name,
              last_update_date: res.entity[0].last_update_date,
            });
          } else {
            this.isCreateProcessing = false;
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.isCreateProcessing = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style scoped>
.no-click {
  color: #ddd;
  cursor: default;
}
</style>